module.exports = __webpack_public_path__ + "static/media/warning-white.d5978867.svg";